import { NavLink } from "react-router-dom";
import Logo from "../images/logo.jpg";
import SearchBox from "./Searchbox";
import Cart from "./Cart";
import Menu3 from "./Menu3.js";
import Canopy from "../images/canopylarge.png";
import ISOCer from "../images/isoCertified.png"
import HorsePng from "../images/udaiBhai.png"

const NavBar = () => {
    return (
        <>
            {/* Navbar */}

            <div className="topBarMain">

                <div className="topBar">
                    <div className="topBarOne">
                        <span style={{ fontFamily: "'Jost', sans-serif", fontWeight: "500" }} >An ISO 9001:2015 Certified Company</span>
                        <img className="isoImg" src={ISOCer} alt="" />
                    </div>
                    <div className="topBarTwo">
                        <i className="fa-brands fa-facebook-f"></i>
                        <a style={{ textDecoration: "none", color: "black" }} href="/">
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                        <a style={{ textDecoration: "none", color: "black" }} href="https://www.google.com/maps/place/HPZ+WORLDWIDE+PRIVATE+LIMITED/@17.3845779,78.453285,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb9972611be379:0x58f98e4ab2925934!8m2!3d17.3845779!4d78.4558599!16s%2Fg%2F11s8y3t5qf?entry=tts&g_ep=EgoyMDI0MTAyMy4wIPu8ASoASAFQAw%3D%3D">
                            <i className="fa-brands fa-google"></i>
                        </a>
                        <a style={{ textDecoration: "none", color: "black" }} href="https://wa.me/919440295353">
                            <i className="fa-brands fa-whatsapp"></i>
                        </a>
                        {/* <i className="fa-brands fa-telegram"></i> */}
                    </div>
                </div>

            </div>

            <div className="navbarMain">

                {/* <center>
                    <img src={Canopy} alt="" className="canopyNav" />
                </center> */}

                {/* desktop */}
                <div className="navBar" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}>

                    <NavLink style={{ textDecoration: "none" }} to="/">
                        {/* <img src={HorsePng} alt="logo" className="logoNav" /> */}
                        <img src={HorsePng} alt="logo" style={{width:"100px", position:"relative"}}/>
                        <img src={Logo} alt="logo" className="logoNav" />
                        {/* <span className="logoMaintext">HPZ</span> */}
                    </NavLink>

                    {/* <i className="fa-solid fa-bars menuNav"></i> */}

                    {/* <MenuBar /> */}
                    <SearchBox />


                    <div className="navAccBox">
                        <NavLink to="/login">
                            <i style={{ color: "black" }} className="fa-regular fa-user userIcon"></i>{/*<span className="superTxt"></span> */}
                        </NavLink>

                        <NavLink to="/wishlist" style={{ textDecoration: "none", color: "black" }}>
                            <i className="fa-regular fa-heart"></i><span className="superTxt">0</span>
                        </NavLink>

                        {/* <i className="fa-solid fa-cart-shopping"></i><span className="superTxt">0</span> */}
                        <Cart /><span className="superTxt">0</span>
                    </div>

                </div>

                {/* mobile */}
                <div className="navBarMobile" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }}>

                    <NavLink style={{ textDecoration: "none" }} to="/">
                        <img src={Logo} alt="logo" className="logoNav logoNavMob" />
                        <img src={HorsePng} alt="logo" className="logoNav" style={{position:"absolute", right:"30px", top:"50px"}}/>
                        {/* <span className="logoMaintextMobile">HPZ</span> */}
                    </NavLink>

                    {/* <MenuBar /> */}
                    <Menu3 />

                </div>

            </div>

            {/* <div className="partOneThree" >
                <div className="toggleDiv" >


                    <div className="dropdown">
                        <p className="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            Kitchen Fittings
                        </p>
                         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><NavLink className="dropdown-item" to="/services/homeloan" >Home Loan</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/personalloan" >Personal Loan</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/businessloan" >Business Loan</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/carloan" >Car Loan</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/educationloan" >Education Loan</NavLink></li>
                        </ul> 
        </div >

                    <div className="dropdown">
                        <p className="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            Wardrobe Fittings
                        </p>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><NavLink className="dropdown-item" to="/services/lifeinsurance" >Life Insurance</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/healthinsurance" >Health Insurance</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/vehicleinsurance" >Vehicle Insurance</NavLink></li>
                        </ul> 
                    </div>

                    <div className="dropdown">
                        <p className="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            Glass Fittings
                        </p>
                         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><NavLink className="dropdown-item" to="/services/labourlicense" >Labour License</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/tradelicense" >Trade License</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/gst" >GST Registration</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/foodlicense" >Food License {"(FSSAI)"} </NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/trademarkreg" >Trademark Registration</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/msme" >MSME</NavLink></li>
                        </ul> 
                    </div>


                    <div className="dropdown">
                        <p type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            Aluminium Profile
                        </p>
                         <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><NavLink className="dropdown-item" to="/services/incometax" >Income Tax</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/accounting" >Accounting</NavLink></li>
                            <li><NavLink className="dropdown-item" to="/services/gstfiling" >GST Filing</NavLink></li>
                        </ul>
                    </div>


                </div > 
        </div >*/}
        </>
    )
}

export default NavBar;